
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/identity-resolution/usage",
      function () {
        return require("private-next-pages/identity-resolution/usage.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/identity-resolution/usage"])
      });
    }
  